<div [formGroup]="parentFormGroup">
    <mat-form-field>
        <input matInput
               [ngxMatDatetimePicker]="picker"
               [max]="maximumDate"
               [min]="minimumDate"
               (blur)="blurred($event)"
               (focus)="focussed()"
               [formControlName]="parentFormControlName">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker [hideTime]="this.hideTime" #picker (opened)="onOpenPicker()" (closed)="onClosePicker()"></ngx-mat-datetime-picker>
    </mat-form-field>
    <span *ngIf="displayPreviousAndActiveDateForDebug">{{_previousAndActiveDate}}</span>
</div>
